var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxIndicator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8281 0.5L17.0918 0.513672C17.7028 0.576032 18.2768 0.847117 18.7148 1.28516C19.2154 1.78574 19.4977 2.46395 19.5 3.17188V16.8291C19.4975 17.5367 19.2152 18.2145 18.7148 18.7148C18.2143 19.2154 17.5361 19.4977 16.8281 19.5H3.17188C2.46395 19.4977 1.78574 19.2154 1.28516 18.7148C0.847115 18.2768 0.576028 17.7028 0.513672 17.0918L0.5 16.8281V3.17188C0.502271 2.46395 0.784572 1.78574 1.28516 1.28516C1.7232 0.847117 2.29724 0.576032 2.9082 0.513672L3.17188 0.5H16.8281Z",
    stroke: "#888DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIndicator);
export default __webpack_public_path__ + "static/media/checkbox-indicator.fbbd5ea4bc83cd86ac3dcea17ffeb1c0.svg";
export { ForwardRef as ReactComponent };